module.exports = __webpack_public_path__ + "img/統計学入門_2_5_問題.a0e51918.png";